import { render, staticRenderFns } from "./conversation-summaries.vue?vue&type=template&id=4d09a258&scoped=true&"
import script from "./conversation-summaries.vue?vue&type=script&lang=js&"
export * from "./conversation-summaries.vue?vue&type=script&lang=js&"
import style0 from "./conversation-summaries.vue?vue&type=style&index=0&id=4d09a258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09a258",
  null
  
)

export default component.exports